<div class="registerCard">
  <h1>Trouble logging in?</h1>
  <h3>
      The Email has expired please sumbit a new token via the <a href="/recovery/forgot-password">forgot password</a> page
  </h3>
</div>
